var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCalendarDark = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 18,
  height: 18,
  viewBox: "0 0 18 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M2 14.75C2 16.025 2.975 17 4.25 17H14.75C16.025 17 17 16.025 17 14.75V8.75H2V14.75ZM14.75 3.5H13.25V2.75C13.25 2.3 12.95 2 12.5 2C12.05 2 11.75 2.3 11.75 2.75V3.5H7.25V2.75C7.25 2.3 6.95 2 6.5 2C6.05 2 5.75 2.3 5.75 2.75V3.5H4.25C2.975 3.5 2 4.475 2 5.75V7.25H17V5.75C17 4.475 16.025 3.5 14.75 3.5Z",
  fill: "#3A414C"
})));
export { SvgCalendarDark as ReactComponent };
export default __webpack_public_path__ + "static/media/calendar-dark.b4ddf66a.svg";